/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  ScheduleVisitTypeGroupStaffApiOutContract,
  ServiceTypeAdminApiInContract,
  ServiceTypeAdminApiOutContract,
  ServiceTypeListItemAdminApiOutContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | NameNotValid | Service type name is empty or too long |
| 400 | DescriptionNotValid | Service type description is empty or too long |
| 400 | VisitTypeNameNotValid | At least one visit type has empty or too long name |
| 400 | VisitTypeDescriptionNotValid | At least one visit type has empty or too long description |
| 400 | VisitTypeDurationNotValid | At least one visit type has duration not from allowed range |
| 400 | VisitTypeCostNotValid | At least one visit type has invalid cost |
| 400 | VisitTypeCancellationFeeNotValid | At least one visit type has invalid cancellation fee |
| 400 | VisitTypeCountNotValid | Array of visit types is null or doesn't have any items |
| 400 | VisitTypeConsentFormCountNotValid | Visit type has no consent forms |
| 400 | VisitTypeVisibilityTypeNotValid | At least one visit type has not supported visibility type. All visit types has "established" visibility type |
| 400 | ScheduleVisitTypeGroupNotValid | At least one schedule visit type group could not be found |
| 401 | | Authentication failed |
| 404 | ServiceTypeNotFound | Service type with sent identifier is not found |
| 404 | VisitTypeNotFound | Visit type with sent identifier is not found |
| 404 | ConsentFormNotFound | Consent form with sent identity is not found |
| 404 | IntakeFormNotFound | Intake form with sent identity is not found |
| 409 | NameNotUnique | Service type name is not unique |
| 409 | VisitTypeNameNotUnique | At least one visit type name is not unique |
| 500 | InternalServerError | Internal server error |
 * @summary Create new service type
 */
export const postServicetypes = (
    serviceTypeAdminApiInContract: ServiceTypeAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ServiceTypeAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceTypeAdminApiInContract, signal
    },
      options);
    }
  


export const getPostServicetypesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServicetypes>>, TError,{data: ServiceTypeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postServicetypes>>, TError,{data: ServiceTypeAdminApiInContract}, TContext> => {

const mutationKey = ['postServicetypes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServicetypes>>, {data: ServiceTypeAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postServicetypes(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServicetypesMutationResult = NonNullable<Awaited<ReturnType<typeof postServicetypes>>>
    export type PostServicetypesMutationBody = ServiceTypeAdminApiInContract
    export type PostServicetypesMutationError = void | ErrorApiOutContract

    /**
 * @summary Create new service type
 */
export const usePostServicetypes = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServicetypes>>, TError,{data: ServiceTypeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postServicetypes>>,
        TError,
        {data: ServiceTypeAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostServicetypesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Return service types + visit types with a subset of data
 */
export const getServicetypes = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ServiceTypeListItemAdminApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes`, method: 'GET', signal
    },
      options);
    }
  



export const getGetServicetypesInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/servicetypes`
    ] as const;
    }

export const getGetServicetypesQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/servicetypes`
    ] as const;
    }

    
export const getGetServicetypesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypes>>> = ({ signal }) => getServicetypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypes>>>
export type GetServicetypesInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypes>>,
          TError,
          Awaited<ReturnType<typeof getServicetypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypes>>,
          TError,
          Awaited<ReturnType<typeof getServicetypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service types + visit types with a subset of data
 */

export function useGetServicetypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Return service types + visit types with a subset of data
 */
export const prefetchGetServicetypesInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypes>>> = ({ signal }) => getServicetypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypes>>>
export type GetServicetypesQueryError = void | ErrorApiOutContract


export function useGetServicetypes<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypes>>,
          TError,
          Awaited<ReturnType<typeof getServicetypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypes<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypes>>,
          TError,
          Awaited<ReturnType<typeof getServicetypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypes<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service types + visit types with a subset of data
 */

export function useGetServicetypes<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Return service types + visit types with a subset of data
 */
export const prefetchGetServicetypesQuery = async <TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypes>>> = ({ signal }) => getServicetypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypes>>>
export type GetServicetypesSuspenseQueryError = void | ErrorApiOutContract


export function useGetServicetypesSuspense<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesSuspense<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesSuspense<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service types + visit types with a subset of data
 */

export function useGetServicetypesSuspense<TData = Awaited<ReturnType<typeof getServicetypes>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServicetypesSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypes>>> = ({ signal }) => getServicetypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypes>>>
export type GetServicetypesSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service types + visit types with a subset of data
 */

export function useGetServicetypesSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypes>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypes>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * See M:Pwrdby.QuickMD.Admins.Api.Controllers.ServiceTypeController.CreateServiceType(Pwrdby.QuickMD.Admins.Api.Contracts.ServiceTypes.ServiceTypeAdminApiInContract) method for possible errors
 * @summary Update service type by id
 */
export const putServicetypesServiceTypeId = (
    serviceTypeId: string,
    serviceTypeAdminApiInContract: ServiceTypeAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ServiceTypeAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes/${encodeURIComponent(String(serviceTypeId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceTypeAdminApiInContract
    },
      options);
    }
  


export const getPutServicetypesServiceTypeIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServicetypesServiceTypeId>>, TError,{serviceTypeId: string;data: ServiceTypeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putServicetypesServiceTypeId>>, TError,{serviceTypeId: string;data: ServiceTypeAdminApiInContract}, TContext> => {

const mutationKey = ['putServicetypesServiceTypeId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServicetypesServiceTypeId>>, {serviceTypeId: string;data: ServiceTypeAdminApiInContract}> = (props) => {
          const {serviceTypeId,data} = props ?? {};

          return  putServicetypesServiceTypeId(serviceTypeId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServicetypesServiceTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServicetypesServiceTypeId>>>
    export type PutServicetypesServiceTypeIdMutationBody = ServiceTypeAdminApiInContract
    export type PutServicetypesServiceTypeIdMutationError = void | ErrorApiOutContract

    /**
 * @summary Update service type by id
 */
export const usePutServicetypesServiceTypeId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServicetypesServiceTypeId>>, TError,{serviceTypeId: string;data: ServiceTypeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServicetypesServiceTypeId>>,
        TError,
        {serviceTypeId: string;data: ServiceTypeAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutServicetypesServiceTypeIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete service type by id
 */
export const deleteServicetypesServiceTypeId = (
    serviceTypeId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes/${encodeURIComponent(String(serviceTypeId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteServicetypesServiceTypeIdMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>, TError,{serviceTypeId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>, TError,{serviceTypeId: string}, TContext> => {

const mutationKey = ['deleteServicetypesServiceTypeId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>, {serviceTypeId: string}> = (props) => {
          const {serviceTypeId} = props ?? {};

          return  deleteServicetypesServiceTypeId(serviceTypeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServicetypesServiceTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>>
    
    export type DeleteServicetypesServiceTypeIdMutationError = void | ErrorApiOutContract

    /**
 * @summary Delete service type by id
 */
export const useDeleteServicetypesServiceTypeId = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>, TError,{serviceTypeId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServicetypesServiceTypeId>>,
        TError,
        {serviceTypeId: string},
        TContext
      > => {

      const mutationOptions = getDeleteServicetypesServiceTypeIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 401 |  | Authentication failed |
| 404 | ServiceTypeNotFound | Service type with sent identifier is not found |
| 500 | InternalServerError | Internal server error |
 * @summary Return service type by id
 */
export const getServicetypesServiceTypeId = (
    serviceTypeId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ServiceTypeAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes/${encodeURIComponent(String(serviceTypeId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetServicetypesServiceTypeIdInfiniteQueryKey = (serviceTypeId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/servicetypes/${serviceTypeId}`
    ] as const;
    }

export const getGetServicetypesServiceTypeIdQueryKey = (serviceTypeId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/servicetypes/${serviceTypeId}`
    ] as const;
    }

    
export const getGetServicetypesServiceTypeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(serviceTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesServiceTypeIdInfiniteQueryKey(serviceTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>> = ({ signal }) => getServicetypesServiceTypeId(serviceTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceTypeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesServiceTypeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>
export type GetServicetypesServiceTypeIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesServiceTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service type by id
 */

export function useGetServicetypesServiceTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesServiceTypeIdInfiniteQueryOptions(serviceTypeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Return service type by id
 */
export const prefetchGetServicetypesServiceTypeIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, serviceTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesServiceTypeIdInfiniteQueryOptions(serviceTypeId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesServiceTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(serviceTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesServiceTypeIdQueryKey(serviceTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>> = ({ signal }) => getServicetypesServiceTypeId(serviceTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(serviceTypeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesServiceTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>
export type GetServicetypesServiceTypeIdQueryError = void | ErrorApiOutContract


export function useGetServicetypesServiceTypeId<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeId<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesServiceTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeId<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service type by id
 */

export function useGetServicetypesServiceTypeId<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesServiceTypeIdQueryOptions(serviceTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Return service type by id
 */
export const prefetchGetServicetypesServiceTypeIdQuery = async <TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, serviceTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesServiceTypeIdQueryOptions(serviceTypeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesServiceTypeIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(serviceTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesServiceTypeIdQueryKey(serviceTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>> = ({ signal }) => getServicetypesServiceTypeId(serviceTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesServiceTypeIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>
export type GetServicetypesServiceTypeIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetServicetypesServiceTypeIdSuspense<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdSuspense<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdSuspense<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service type by id
 */

export function useGetServicetypesServiceTypeIdSuspense<TData = Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesServiceTypeIdSuspenseQueryOptions(serviceTypeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServicetypesServiceTypeIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(serviceTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesServiceTypeIdInfiniteQueryKey(serviceTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>> = ({ signal }) => getServicetypesServiceTypeId(serviceTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesServiceTypeIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>
export type GetServicetypesServiceTypeIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesServiceTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesServiceTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return service type by id
 */

export function useGetServicetypesServiceTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>>, TError = void | ErrorApiOutContract>(
 serviceTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesServiceTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesServiceTypeIdSuspenseInfiniteQueryOptions(serviceTypeId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | ServiceTypeOrderNotValid | Array of service type identities is empty |
| 401 | | Authentication failed |
| 500 | InternalServerError | Internal server error |
 * @summary This method provides ability to reorder service types. API assumes full list of service type identities is sent.
If identity of a service type wasn't sent -- it's order will be changed on default one (after service types with set order, by creation date desc)
 */
export const putServicetypesReorder = (
    putServicetypesReorderBody: string[],
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes/reorder`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putServicetypesReorderBody
    },
      options);
    }
  


export const getPutServicetypesReorderMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServicetypesReorder>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putServicetypesReorder>>, TError,{data: string[]}, TContext> => {

const mutationKey = ['putServicetypesReorder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServicetypesReorder>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  putServicetypesReorder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServicetypesReorderMutationResult = NonNullable<Awaited<ReturnType<typeof putServicetypesReorder>>>
    export type PutServicetypesReorderMutationBody = string[]
    export type PutServicetypesReorderMutationError = void | ErrorApiOutContract

    /**
 * @summary This method provides ability to reorder service types. API assumes full list of service type identities is sent.
If identity of a service type wasn't sent -- it's order will be changed on default one (after service types with set order, by creation date desc)
 */
export const usePutServicetypesReorder = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServicetypesReorder>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServicetypesReorder>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getPutServicetypesReorderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */
export const getServicetypesVisitTypeGroups = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ScheduleVisitTypeGroupStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/servicetypes/visitTypeGroups`, method: 'GET', signal
    },
      options);
    }
  



export const getGetServicetypesVisitTypeGroupsInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/servicetypes/visitTypeGroups`
    ] as const;
    }

export const getGetServicetypesVisitTypeGroupsQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/servicetypes/visitTypeGroups`
    ] as const;
    }

    
export const getGetServicetypesVisitTypeGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesVisitTypeGroupsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>> = ({ signal }) => getServicetypesVisitTypeGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesVisitTypeGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>
export type GetServicetypesVisitTypeGroupsInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesVisitTypeGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */

export function useGetServicetypesVisitTypeGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesVisitTypeGroupsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */
export const prefetchGetServicetypesVisitTypeGroupsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesVisitTypeGroupsInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesVisitTypeGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesVisitTypeGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>> = ({ signal }) => getServicetypesVisitTypeGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesVisitTypeGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>
export type GetServicetypesVisitTypeGroupsQueryError = void | ErrorApiOutContract


export function useGetServicetypesVisitTypeGroups<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroups<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroups<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */

export function useGetServicetypesVisitTypeGroups<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesVisitTypeGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */
export const prefetchGetServicetypesVisitTypeGroupsQuery = async <TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetServicetypesVisitTypeGroupsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetServicetypesVisitTypeGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesVisitTypeGroupsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>> = ({ signal }) => getServicetypesVisitTypeGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesVisitTypeGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>
export type GetServicetypesVisitTypeGroupsSuspenseQueryError = void | ErrorApiOutContract


export function useGetServicetypesVisitTypeGroupsSuspense<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsSuspense<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsSuspense<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */

export function useGetServicetypesVisitTypeGroupsSuspense<TData = Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesVisitTypeGroupsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetServicetypesVisitTypeGroupsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServicetypesVisitTypeGroupsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>> = ({ signal }) => getServicetypesVisitTypeGroups(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServicetypesVisitTypeGroupsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>
export type GetServicetypesVisitTypeGroupsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetServicetypesVisitTypeGroupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServicetypesVisitTypeGroupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the list of VisitTypeGroups that can be assigned to a VisitType.
 */

export function useGetServicetypesVisitTypeGroupsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getServicetypesVisitTypeGroups>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServicetypesVisitTypeGroupsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




